import Vue from "vue";
import ServiceStatusListSelect from "../../shared/ServiceStatusListSelect";
export default Vue.extend({
  template: `
  <div style="padding:15px;">
  <service-status-list-select
                        :is-disabled="false"
                        v-model="status"
                        @onSelect="onItemStatusSelect"
                      ></service-status-list-select>
  </div>
    `,
  components: { ServiceStatusListSelect },
  data: function () {
    return {
      status: "",
      statusName: "",
    };
  },

  mounted() {},

  methods: {
    onItemStatusSelect(payload) {
      this.statusName = payload.name;
      this.params.data.statusId = payload.id;
      this.params.api.stopEditing();
    },
    getValue() {
      return this.statusName;
    },
    isPopup() {
      return true;
    },
  },
  beforeMount() {
    this.status = this.params.data.statusId;
    this.statusName = this.params.data.status;
  },
});



// WEBPACK FOOTER //
// ./src/components/gt/shared/ag-grid/AgServiceStatusEditor.js